import { createLogic } from "redux-logic";
import type { CarConfigLogicType } from "../store";
import { setExternalPriceTaxLocation } from "../slices/carConfigExternalPriceSlice";
import { calculatePrice } from "../slices/CarConfigBasketSlice";
import { getSessionStorageParams, setTaxLocationIdToStorage } from "../../utils/sessionStorage";
import { startConfigSave } from "../slices/CarConfigSaveSlice";

const setTaxLocationExternalPriceLogic = (
    createLogic as CarConfigLogicType<ReturnType<typeof setExternalPriceTaxLocation>>
)({
    type: setExternalPriceTaxLocation.type,

    process({ action, getState }, dispatch, done) {
        const sessionStorageParams = getSessionStorageParams(getState());
        setTaxLocationIdToStorage(sessionStorageParams, action.payload.locationId || "");

        // Calculate price with the new taxLocation
        dispatch(calculatePrice({ loadExternalPrice: true }));
        // Save the config again as price calculation has changed
        dispatch(startConfigSave());

        done();
    },
});

export default [setTaxLocationExternalPriceLogic];
